import { IaChatAmountMode, IaChatQuickReply, IaChatTopic } from './ia-chat-quote-script';

export type IaChatSender = 'user' | 'ia' | 'system';
export type IaChatMessageType =
    | 'text'
    | 'image'
    | 'groupImage'
    | 'video'
    | 'favoriteField'
    | 'typeSelection'
    /** Botões do roteiro do orçamento (Sim/Não e o modo do valor). */
    | 'quickReply';
export type IaChatUploadStatus = 'idle' | 'uploading' | 'done' | 'error';

export interface IaChatMessage {
    id: string;
    sender: IaChatSender;
    type: IaChatMessageType;
    createdAt: string;
    text?: string;
    translationKey?: string;
    /** Parâmetros da chave (ex.: `{ currency: 'R$' }` na pergunta do modo). */
    translationParams?: Record<string, string>;
    mediaPaths: string[];
    mediaUrls: string[];
    mediaKeys: string[];
    /** Tamanho em bytes de cada mídia (ordem de `mediaUrls`) — vira o `size` do item no documento. */
    mediaSizes: number[];
    /** Miniatura de cada vídeo (ordem de `mediaUrls`) — vira o `thumbUrl` do item. */
    mediaThumbUrls: string[];
    /** Duração em segundos de cada vídeo (ordem de `mediaUrls`). */
    mediaDurations: number[];
    uploadStatus: IaChatUploadStatus;
    uploadProgress?: number;
    favoriteFieldId?: string;
    /** Etapa do roteiro em que a fala foi dita (ausente na conversa livre). */
    topic?: IaChatTopic;
    /** Modo escolhido nos botões — anexado à fala que traz o valor. */
    amountMode?: IaChatAmountMode;
    /** Botões oferecidos por uma mensagem `quickReply` do roteiro local. */
    quickReplies?: IaChatQuickReply[];
    /**
     * Botões sugeridos pela IA (POC `chat-live-ia`): já são o texto final, no idioma
     * da conversa. Diferente de `quickReplies`, que é um enum traduzido no cliente.
     */
    quickReplyLabels?: string[];
    /** `true` depois de respondida (por clique ou por escrito): os botões somem. */
    answered?: boolean;
}

export function createIaChatMessage(
    data: Partial<IaChatMessage> & Pick<IaChatMessage, 'sender' | 'type'>
): IaChatMessage {
    return {
        id: `${Date.now()}-${crypto.randomUUID?.() ?? Math.random().toString(36).slice(2)}`,
        createdAt: new Date().toISOString(),
        mediaPaths: [],
        mediaUrls: [],
        mediaKeys: [],
        mediaSizes: [],
        mediaThumbUrls: [],
        mediaDurations: [],
        uploadStatus: 'idle',
        uploadProgress: 0,
        ...data,
    };
}
